<template>
  <div class="user">
    <h2 class="project-subtitle">{{ Translator('soprasolar.project.user.title') }}</h2>
    <p>
      {{ Translator('soprasolar.project.step1.form.company') }} :
      <strong>{{ datas.step1.company }}</strong>
    </p>
    <p v-if="datas.step1.siren">
      {{ Translator('soprasolar.project.step1.form.siren') }} :
      <strong>{{ format(datas.step1.siren) }}</strong>
    </p>
    <p v-if="datas.step1.siret">
      {{ Translator('soprasolar.project.step1.form.siret') }} :
      <strong>{{ format(datas.step1.siret) }}</strong>
    </p>
    <p v-if="datas.step1.street">
      {{ Translator('soprasolar.project.step1.form.street') }} :
      <strong>{{ datas.step1.street }}</strong>
    </p>
    <p>
      {{ Translator('soprasolar.project.step1.form.zip_code') }} :
      <strong>{{ datas.step1.zipCode }}</strong>
    </p>
    <p>
      {{ Translator('soprasolar.project.step1.form.city') }} :
      <strong>{{ datas.step1.city }}</strong>
    </p>
    <p v-if="datas.step1.country">
      {{ Translator('soprasolar.project.step1.form.country') }} :
      <strong>{{ getCountryName(datas.step1.country) }}</strong>
    </p>
    <p>
      {{ Translator('soprasolar.project.step1.form.occupation') }} :
      <strong>{{ Translator('soprasolar.project.step1.form.occupation_options.' + datas.step1.occupation ) }}</strong>
    </p>
    <p class="label-separator">{{ Translator('soprasolar.project.step1.form.contact_legend') }}</p>
    <p>
      {{ Translator('soprasolar.project.step1.form.first_name') }} :
      <strong>{{ datas.step1.firstName }}</strong>
    </p>
    <p>
      {{ Translator('soprasolar.project.step1.form.last_name') }} :
      <strong>{{ datas.step1.lastName }}</strong>
    </p>
    <p>
      {{ Translator('soprasolar.project.step1.form.email') }} :
      <strong>{{ datas.step1.email }}</strong>
    </p>
    <p>
      {{ Translator('soprasolar.project.step1.form.phone_number') }} :
      <strong>{{ datas.step1.phoneNumber }}</strong>
    </p>
    <template v-if="isAdmin">
      <button type="button" class="demand-button" @click="onCheckSalesForce()" v-if="!datas.salesforceId">{{ Translator('soprasolar.project.resume.salesforce_button') }}</button>
      <template v-if="datas.salesforceId">
        <p class="salesforce-valid">
          <i class="ic ic-checked-round"></i>
          <template v-if="datas.salesforceType === 'contact'">
            {{ Translator('soprasolar.project.resume.salesforce_sync_contact') }}
          </template>
          <template v-else-if="datas.salesforceType === 'close'">
            {{ Translator('soprasolar.project.resume.salesforce_sync_closed') }}
          </template>
          <template v-else>
            {{ Translator('soprasolar.project.resume.salesforce_sync_all') }}
          </template>
        </p>
      </template>
    </template>
  </div>
</template>
<style scoped lang="scss">
  @import "~@/soprasolar-project/assets/styles/import";
  .user {
    width: 100%;
    border: rem(1) solid $grey-light;
    padding: rem(20) rem(30);
    border-radius: rem(8);
    margin-bottom: rem(30);
    min-width: rem(250);
    @include desktop {
      min-width: rem(400);
    }
  }
  .salesforce-valid {
    display: flex;
    align-items: center;
    color: $color-success;
    margin-top: rem(20);
    gap: rem(10);
    .ic {
      font-size: rem(20);
    }
  }
  .label-separator {
    font-size: rem(16);
    color: $color-main;
    margin-top: rem(20);
    margin-bottom: rem(5);
  }
  .demand-button {
    @include cta;
    margin-top: rem(20);
  }
</style>
<script>
import AppControlService from '@/soprasolar-project/services/AppControl';
import AppControl from '@/soprasolar-project/services/AppControl';
import countryList from 'country-list-js';

export default {
  name: 'user',
  components: {},
  data () {
    return {
      datas: AppControlService.datas
    }
  },

  computed: {
    isAdmin: () => {
      return AppControlService.isAdmin;
    }
  },

  created() {
    AppControlService.on('datas', this._onUpdateDatas);
  },

  beforeDestroy() {
    AppControlService.off('datas', this._onUpdateDatas);
  },

  methods: {
    getCountryName(code) {
      return countryList.findByIso2(code)?.name;
    },

    onCheckSalesForce() {
      AppControlService.popinSalesForceToggle(true);
    },

    format(number) {
      return AppControl.format(number);
    },

    _onUpdateDatas(datas) {
      this.datas = datas;
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },
  }
}
</script>